import React from 'react'
import Header from '../Header.js'

function Home() {
  return (
    <div>
      
      <Header></Header>
    </div>
  )
}

export default Home